/* eslint no-unused-vars: 0 */

import React from 'react';
import { handleUnit, normalisePrice } from 'lib/utils';
import { branchTermSingularCapitalised } from 'utils/terminology';
import getBadgeVariant from 'utils/getBadgeVariant';
import Button from 'components/ui-components/Button';
import ProductBadge from 'components/product_show/product_badge';
import { ctaGreen } from 'constants/variables';

import SiteSearchProductNoResults from './product_no_results';

// Added as intrim to remove eslint no nested ternary error
const StockInfo = ({ collectionOnly, b2bStockLevel }) => {
  if (collectionOnly) {
    return 'Collection Only';
  }
  if (b2bStockLevel > 0) {
    return (
      <div>
        <div>
          <strong>Delivery</strong>
        </div>
        <div>
          <strong className="instock">{b2bStockLevel}</strong> in stock
        </div>
      </div>
    );
  }
  return 'Out of Stock';
};

class SiteSearchProductResults extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getPrice = this.getPrice.bind(this);
  }

  getPrice(id, priceBeforeCurrentSale, isOnClearance) {
    const { prices, vat_exclusive: vatExclusive } = this.props;
    const price = prices[id];

    return price !== undefined ? (
      <div className="price">
        <div className="price-inc-moq">
          <span
            className={`priceValue${
              priceBeforeCurrentSale || isOnClearance
                ? ' tc-cef-red'
                : ' tc-black'
            }`}>
            {normalisePrice(vatExclusive ? price.price : price.price_inclusive)}{' '}
          </span>

          <span className="moq">
            {' '}
            For {price.quantity}
            {handleUnit(price.unit)}
          </span>
        </div>
        <div className="vat-switch">
          {vatExclusive ? (
            <span>{normalisePrice(price.price_inclusive)} inc VAT</span>
          ) : (
            <span>{normalisePrice(price.price)} ex VAT</span>
          )}
        </div>
      </div>
    ) : (
      ''
    );
  }

  render() {
    const {
      assets,
      b2bPhoneNumber,
      customerServicesEmail,
      fullSearch,
      loadingPrices,
      products,
      query,
      viewLink,
    } = this.props;

    return (
      <div className="v2-span9 product-results">
        {products.length > 0 ? (
          <h3>Popular Products</h3>
        ) : (
          <SiteSearchProductNoResults
            customerServicesEmail={customerServicesEmail}
            b2bPhoneNumber={b2bPhoneNumber}
            assets={assets}
            query={query}
          />
        )}
        <ul>
          {products.map((p, index) => {
            const {
              segen_logistical_partner: segenLogisticalPartner,
              active_online_sale_price_inc_vat: priceBeforeCurrentSaleIncVAT,
              active_online_sale_price: priceBeforeCurrentSale,
              marketing_alias_clearance: isOnClearance,
              marketing_alias_redemption: isRedemptionOffer,
            } = p;

            const badgeVariant = getBadgeVariant({
              priceBeforeCurrentSale,
              priceBeforeCurrentSaleIncVAT,
              isOnClearance,
              isRedemptionOffer,
            });

            return (
              <li key={p.id}>
                <div
                  role="presentation"
                  onClick={e => {
                    if (window.dataLayer) {
                      window.dataLayer.push({
                        event: 'AutoSearchPopular',
                        name: p.description_short,
                        stockCode: p.stock_code,
                        searchUsed: query,
                        position: index + 1,
                      });
                    }
                    viewLink(p.url);
                  }}>
                  <div className="search-result">
                    <div className="sr-product-image">
                      <img
                        src={p.image_small}
                        className="product-thumbnail"
                        alt=""
                      />
                    </div>
                    <div className="sr-brand-image">
                      {p.brand_image !== null ? (
                        <img
                          src={p.brand_image}
                          className="product-brand-thumbnail"
                          alt=""
                        />
                      ) : (
                        ''
                      )}
                    </div>

                    <div className="product--detail">
                      <div>
                        <strong className="description">
                          {p.description_short}
                        </strong>
                        <br />
                        <div className="fl fl-row fw-w g-8">
                          <span className="ws-nw">
                            <span>Part Code:</span>{' '}
                            <strong className="tc-cef-grey">
                              {p.catalogue}
                            </strong>{' '}
                          </span>
                          <span className="ws-nw">
                            <span>Stock Code:</span>{' '}
                            <strong className="tc-cef-grey">
                              {p.stock_code}
                            </strong>
                          </span>
                        </div>
                      </div>
                      <div className="fl">
                        {badgeVariant && (
                          <ProductBadge variant={badgeVariant} />
                        )}
                        {loadingPrices && !segenLogisticalPartner && (
                          <div className="loader fl-shrink-0">&nbsp;</div>
                        )}
                        {!segenLogisticalPartner &&
                          this.getPrice(
                            p.id,
                            priceBeforeCurrentSale,
                            isOnClearance,
                          )}
                      </div>
                    </div>

                    <div
                      className={`stock-level ${
                        p.b2b_stock_level <= 0 ? 'out-of-stock' : ''
                      }`}>
                      {p.third_party_logistical_partner ? (
                        <span className="ta-c contact-store">
                          <strong>
                            Contact {branchTermSingularCapitalised} for Details
                          </strong>
                        </span>
                      ) : (
                        <StockInfo
                          collectionOnly={p.collection_only}
                          b2bStockLevel={p.b2b_stock_level}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
          {products.length > 0 ? (
            <li>
              <Button
                type="button"
                bgColour={ctaGreen}
                handleClick={() => {
                  fullSearch();
                }}>
                SHOW ALL RESULTS
              </Button>
            </li>
          ) : (
            ''
          )}
        </ul>
      </div>
    );
  }
}

export default SiteSearchProductResults;
